



































































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import SwiperNews from "@/zh-website/src/components/website/Swiper/SwiperNews.vue";
import SwiperCase from "@/zh-website/src/components/website/Swiper/SwiperCase.vue";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
import Dynamic from "@/zh-website/src/components/website/Dynamic.vue";
// 引入背景组件
import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
import { NewsService } from "@/zh-website/src/views/Content/service/newsService";
import { IndustryService } from "./service/IndustryService";

@Component({
  components: {
    SideBar,
    Swiper,
    SwiperSlide,
    SwiperNews,
    Banner,
    Dynamic,
    SwiperCase
  }
})
export default class IndustryIndex extends Vue {
  dynamicList = {
    title: "培训动态",
    list: [] as any
  };
  // 背景图样式文案
  list = {
    style: {
      "background-image": `url(${require("../../assets/data030.png")})`,
      height: "493px"
    },
    font1: "行业人才发展",
    font2: "培育数字人才 联接智能未来",
    font3: "",
    font4: "",
    font5: "",
    button: ""
  };
  rightNew = [];
  leftNew = {};
  caseList: any[] = [];
  caseJump: any[] = [];
  newjump = "/home/news/det/";
  swiperOption = {
    direction: "horizontal",
    loop: true,
    centeredSlides: true,
    slidesPerView: "auto",
    spaceBetween: "5%",
    effect: "coverflow",
    autoplay: true,
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 0,
      modifier: 2,
      slideShadows: false
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  };
  showImg = true;
  // 行业分类介绍
  industryList: any = [];
  // 行业首页成功案例
  successList = [
    {
      dictName: "数字政府",
      content1: "华为携手兰州新区共建“智慧城市ICT人才发展” 顶层设",
      field3: require("../../assets/success3.png")
    },
    {
      dictName: "金融",
      content1: "敏捷咨询助力民生银行全国网络运维人员定制化技能提升",
      field3: require("../../assets/success1.png")
    },
    {
      dictName: "交通",
      content1: "铁路训战课程助力成都局集团有限公司无线专家培养",
      field3: require("../../assets/success2.png")
    }
  ];

  mounted() {
    const _this = this;

    _this._getRightNew();
    this._getSuccessList();
    this.getClassificationList();
  }
  getClassificationList() {
    //
    IndustryService.getClassification({ type: 1 }).then((res: any) => {
      res.data.list.forEach((item: any) => {
        this.industryList.push({
          keywords: item.resourceUrl,
          link: item.jumpLink,
          id: item.jumpLink,
          dictName: item.title,
          extend1: item.subtitle
        });
      });
    });
  }
  //右侧新闻动态
  async _getRightNew() {
    NewsService.getNewsList({ pageNum: 1, pageSize: 5, timeFrameCode: 1 }).then(
      (res: any) => {
        if (res.data.list.length > 0) {
          this.leftNew = res.data.list[0];
          this.rightNew = res.data.list.slice(1, res.data.list.length);
        } else {
          this.leftNew = {};
          this.rightNew = [];
        }
      }
    );
  }
  // 获取首页成功案例
  async _getSuccessList() {
    IndustryService.getSuccessCase({ navigationId: 1 }).then((res: any) => {
      res.data.list.forEach((item: any) => {
        this.caseList.push({
          dictName: item.classificationName,
          content1: item.title,
          field1: item.title,
          id: `all-success-case/detail/${item.id}`,
          field3: `background-image:url("${item.resourceUrl}")`
        });
      });
    });
  }

  on_top_enter() {
    (this.$refs.mySwiper as any).$swiper.autoplay.stop();
  }
  on_top_leave() {
    (this.$refs.mySwiper as any).$swiper.autoplay.start();
  }
}
